module.exports = __webpack_public_path__ + "static/media/item3.9543efc8.png";